import ReactGA from "react-ga4";
import { concatAction, concatSubAction } from "../analytics/Action";
import { cancatCategory, concatCallCategory } from "../analytics/Category";

export function logEvent(catObj, actionObj) {
  // console.log('--------obj------->', catObj, actionObj);
  const category = cancatCategory(catObj.screen, catObj.event);
  const action = concatAction(actionObj);
  console.log("-------category------->", category, action);
  ReactGA.event({
    category,
    action,
  });
}

export function logCallEvent(catObj, actionObj) {
  // console.log('--------obj------->', catObj, actionObj);
  const category = concatCallCategory(catObj.screen, catObj.event);
  const action = concatAction(actionObj);
  console.log("-------category------->", category, action);
  ReactGA.event({
    category,
    action,
  });
}

export function logSubEvent(catObj, actionObj) {
  // console.log('--------obj------->', catObj, actionObj);
  const category = cancatCategory(catObj.screen, catObj.event);
  const action = concatSubAction(actionObj);
  console.log("-------category------->", category, action);
  ReactGA.event({
    category,
    action,
  });
}
